import React, { useState, useEffect } from 'react';
import { ConditionalLink } from '@plone/volto/components';
import { flattenToAppURL } from '@plone/volto/helpers';
import { Image } from 'semantic-ui-react';
import "./theme/_main.scss"
import { TextBlockView } from '@plone/volto-slate/blocks/Text';
import { DetachedTextBlockEditor } from '@plone/volto-slate/blocks/Text/DetachedTextBlockEditor';
import FadeInSection from "../../customizations/components/theme/Animations/FadeInSection"

const View = (props) => {
    const { data, isEditMode, filteredToolbarProps } = props;

    if (!data) {
        return <div>missing data</div>;
    }
    const leftDesignElem = (
        <div className='leftDesign' aria-hidden="true">
            <svg width="620" xmlns="http://www.w3.org/2000/svg" height="15" fill="none">
                <path d="M0 7.5H600" className="fills" />
                <g className="strokes">
                    <path
                        d="M0 7.5H600"
                        style={{
                            fill: 'none',
                            strokeWidth: 5,
                            stroke: 'rgb(255, 255, 255)',
                            strokeOpacity: 1,
                            strokeDasharray: '0, 10',
                            strokeLinecap: 'round',
                        }}
                        className="stroke-shape"
                    />
                </g>
                <path
                    d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
                    style={{
                        fill: 'rgb(255, 255, 255)',
                        fillOpacity: 1,
                    }}
                    className="fills"
                />
                <g className="strokes">
                    <path
                        d="M607.071 0c4.14 0 7.5 3.361 7.5 7.5 0 4.139-3.36 7.5-7.5 7.5a7.504 7.504 0 0 1-7.5-7.5c0-4.139 3.361-7.5 7.5-7.5Zm0 3a4.502 4.502 0 0 0-4.5 4.5c0 2.484 2.017 4.5 4.5 4.5 2.484 0 4.5-2.016 4.5-4.5s-2.016-4.5-4.5-4.5Z"
                        style={{
                            fill: 'none',
                            strokeWidth: 1,
                            stroke: 'rgb(255, 255, 255)',
                            strokeOpacity: 1,
                        }}
                        className="stroke-shape"
                    />
                </g>
            </svg>
        </div>
    );


    return (
        <FadeInSection>
            <section className="custom-block button-highlight">
                <div className="ui twelve column grid column-grid">
                    <div className={`six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper`}>
                        <div className='tile'>
                            {data.title && <h2>{data.title}</h2>}
                            {isEditMode ? (<DetachedTextBlockEditor {...filteredToolbarProps} />) : (<TextBlockView {...props} />)}
                            {leftDesignElem}
                            {data.showButton && (
                                <ConditionalLink to={flattenToAppURL(data.link)} condition={!isEditMode}>
                                    <div className='pretty'>
                                        <button aria-label={data.textButton}>
                                            {data.textButton}
                                        </button>
                                    </div>
                                </ConditionalLink>
                            )}
                        </div>
                    </div>
                    <div className={`six wide computer twelve wide mobile six wide tablet column column-blocks-wrapper`}>
                        <div className='tile'>
                            {data.image &&
                                <Image
                                    src={flattenToAppURL(data.image['@id'] + '/@@images/image')}
                                    alt={data.alt || data.title || 'Decorative Image'}
                                    aria-hidden={!(data.alt || data.title)}
                                />}
                        </div>
                    </div>
                </div>
            </section>
        </FadeInSection>
    );
};

export default View;